import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  width: 100vw;
  position: relative;
  text-align: right;
  height: 207px;
  object-fit: cover;

  div {
    width: 100vw;
    object-fit: cover;
  }
`;
